import { ExtendedAccountColumns, ExtendedAccountData } from '@/backend/features/contact-management/entities/extended-account/types';
import { accountEntityName } from '@juvare/contact-management/backend/features/accounts/shared';
import { StorageClient } from '@juvare/platform-sdk-js/StorageClient';
import { useStorageClient } from '@juvare/platform-sdk-react/ui/hooks';

export function useExtendedAccountStorage(): StorageClient<ExtendedAccountData, ExtendedAccountColumns> {
    return useStorageClient<ExtendedAccountData, ExtendedAccountColumns>(accountEntityName);
}
